import { styled, Box, Button as MuiButton } from '../../base';

export const LEFT_SIDEMENU_WIDTH = 200;
export const RIGHT_SIDEMENU_WIDTH = 300;
export const HEADER_HEIGHT = 60; // Value in pixels

export const Container = styled(Box)({
    display: 'flex',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
});

export const LeftSidemenu = styled(Box)(({ theme }) => ({
    width: `${LEFT_SIDEMENU_WIDTH}px`,
    backgroundColor:
        theme.palette.mode === 'dark'
            ? theme.palette.grey[900]
            : theme.palette.background.mainBackground,
    padding: theme.spacing(2),
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflow: 'hidden',
    flexShrink: 0,
    boxShadow: theme.shadows[10],
}));

export const MainContentArea = styled(Box)({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100vh',
});

export const Header = styled(Box)(({ theme }) => ({
    height: `${HEADER_HEIGHT}px`,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0, 3), // Increased horizontal padding for logo and icon button
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Logo left, Icon button right
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.appBar,
    flexShrink: 0,
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
}));

export const TopContentSection = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflowY: 'auto',
    padding: theme.spacing(1.5, 4),

    // Webkit (Chrome, Safari, Edge) custom overlay scrollbar
    '&::-webkit-scrollbar': {
        width: '8px', // Width of the scrollbar. Adjust as needed.
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent', // Makes the track invisible, scrollbar floats over content.
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.3)', // Color of the scrollbar thumb. Adjust opacity/color.
        borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(0,0,0,0.5)', // Darker on hover
    },

    // Firefox scrollbar styling (less about overlay, more about thin/stable)
    scrollbarWidth: 'thin', // Makes scrollbar thinner in Firefox
    scrollbarColor: `${theme.palette.action.disabled} transparent`, // Thumb color and track color (transparent track)
}));

export const BottomResponseAreaWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    flexShrink: 0,
    padding: theme.spacing(1.5, 4, 2, 4),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
}));

export const SendButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end',
});

export const SendButtonStyled = styled(MuiButton)(() => ({
    // Specific styling for the send button if needed
}));

export const RightSidemenu = styled(Box)(({ theme }) => ({
    width: `${RIGHT_SIDEMENU_WIDTH}px`,
    backgroundColor:
        theme.palette.mode === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.background.paper, // Changed from grey[50] to paper for consistency
    borderLeft:
        theme.direction === 'rtl'
            ? 'none'
            : `1px solid ${theme.palette.divider}`,
    borderRight:
        theme.direction === 'rtl'
            ? `1px solid ${theme.palette.divider}`
            : 'none',
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflow: 'hidden', // To ensure internal scrolling for its content
    flexShrink: 0,
}));
